import { createGlobalStyle } from "styled-components";

/** Estilos para Modal.confirm / useModal con className dark-confirm-modal */
export const DarkConfirmGlobalStyle = createGlobalStyle`
  .dark-confirm-modal {
    .ant-modal-content {
      background: linear-gradient(
        165deg,
        #1a1a2e 0%,
        #16213e 50%,
        #0f3460 100%
      ) !important;
      border-radius: 20px !important;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 24px 48px rgba(0, 0, 0, 0.5) !important;
      padding: 0 !important;
    }

    .ant-modal-body {
      padding: 24px !important;
    }

    .ant-modal-confirm-body-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 16px;
    }

    .ant-modal-confirm-paragraph {
      max-width: none;
    }

    .ant-modal-confirm-title {
      color: #e8eaf0 !important;
      font-weight: 700 !important;
      font-size: 16px !important;
      line-height: 1.4;
    }

    .ant-modal-confirm-content {
      color: #b8bdd4 !important;
      font-size: 14px;
      margin-top: 8px !important;
    }

    .ant-modal-confirm-btns {
      margin-top: 20px !important;

      .ant-btn {
        height: 40px;
        padding-inline: 20px;
        font-weight: 600;
        border-radius: 10px !important;
      }

      .ant-btn-default {
        background: rgba(255, 255, 255, 0.06) !important;
        border-color: rgba(255, 255, 255, 0.15) !important;
        color: #b8bdd4 !important;
      }

      .ant-btn-default:hover {
        background: rgba(255, 255, 255, 0.1) !important;
        border-color: rgba(255, 255, 255, 0.25) !important;
        color: #e8eaf0 !important;
      }

      .ant-btn-primary:not(.ant-btn-dangerous) {
        background: linear-gradient(
          135deg,
          rgba(99, 102, 241, 0.95),
          rgba(79, 70, 229, 0.95)
        ) !important;
        border: none !important;
        box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35) !important;
      }

      .ant-btn-primary:not(.ant-btn-dangerous):hover {
        background: linear-gradient(
          135deg,
          rgba(99, 102, 241, 1),
          rgba(79, 70, 229, 1)
        ) !important;
      }

      .ant-btn-dangerous {
        background: linear-gradient(
          135deg,
          rgba(239, 68, 68, 0.9),
          rgba(220, 38, 38, 0.9)
        ) !important;
        border: none !important;
        color: #fff !important;
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3) !important;
      }

      .ant-btn-dangerous:hover {
        background: linear-gradient(
          135deg,
          rgba(239, 68, 68, 1),
          rgba(220, 38, 38, 1)
        ) !important;
      }
    }
  }
`;
